import type { ReadonlyURLSearchParams } from 'next/navigation';

export class NextUrlConstructor {
	private searchParams: URLSearchParams;
	private pathname: string;

	constructor(pathname: string, searchParams: ReadonlyURLSearchParams) {
		this.searchParams = new URLSearchParams(searchParams.toString());
		this.pathname = pathname;
	}

	get(name: string) {
		return this.searchParams.get(name);
	}

	has(name: string) {
		return this.searchParams.has(name);
	}

	set(name: string, value: string | number) {
		this.searchParams.set(name, value.toString());
		return this;
	}

	delete(name: string) {
		this.searchParams.delete(name);
		return this;
	}

	getQuery() {
		return this.searchParams.toString();
	}

	getUrl() {
		return `${this.pathname}?${this.getQuery()}`;
	}
}
